import { Link } from "react-router-dom";

const footerServices = [
  { label: "Persianas", path: "/servicios/persianas", icon: "ri-window-line" },
  { label: "Mosquiteras", path: "/servicios/mosquiteras", icon: "ri-shield-check-line" },
  { label: "Motorización", path: "/servicios/motorizacion", icon: "ri-remote-control-line" },
  { label: "Guías de reparación", path: "/guias", icon: "ri-book-open-line" },
];

const footerBarrios = [
  { label: "Centro Histórico", path: "/barrios/centro-historico" },
  { label: "La Malagueta", path: "/barrios/la-malagueta" },
  { label: "El Palo", path: "/barrios/el-palo" },
  { label: "Pedregalejo", path: "/barrios/pedregalejo" },
  { label: "Teatinos", path: "/barrios/teatinos" },
  { label: "El Limonar", path: "/barrios/el-limonar" },
  { label: "Churriana", path: "/barrios/churriana" },
  { label: "Carretera de Cádiz", path: "/barrios/carretera-de-cadiz" },
  { label: "Cruz de Humilladero", path: "/barrios/cruz-de-humilladero" },
  { label: "Bailén-Miraflores", path: "/barrios/bailen-miraflores" },
  { label: "Ciudad Jardín", path: "/barrios/ciudad-jardin" },
  { label: "Puerto de la Torre", path: "/barrios/puerto-de-la-torre" },
  { label: "Campanillas", path: "/barrios/campanillas" },
  { label: "Huelin", path: "/barrios/huelin" },
  { label: "Soliva", path: "/barrios/soliva" },
  { label: "El Cónsul", path: "/barrios/el-consul" },
];

const footerLegal = [
  { label: "Sobre Nosotros", path: "/sobre-nosotros" },
  { label: "Aviso Legal", path: "/aviso-legal" },
  { label: "Privacidad", path: "/privacidad" },
  { label: "Cookies", path: "/cookies" },
];

export default function Footer() {
  return (
    <footer className="w-full">
      {/* CTA bar */}
      <div className="bg-gradient-to-r from-primary-500 to-primary-600">
        <div className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-background-50 font-heading">Presupuesto sin compromiso</h3>
              <p className="text-sm text-background-50/80 mt-1">951 12 07 70 · WhatsApp · Respuesta en 24/48h</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:+34951120770"
                className="inline-flex items-center justify-center gap-2 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold text-sm px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base"></i></span>
                951 12 07 70
              </a>
              <a
                href="https://wa.me/34627213347"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-accent-400 hover:bg-accent-500 text-background-50 font-semibold text-sm px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill text-base"></i></span>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-secondary-900">
        <div className="px-4 md:px-6 py-12 md:py-16 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
            {/* Brand */}
            <div className="lg:col-span-3">
              <Link to="/" className="inline-block mb-5">
                <span className="text-xl font-bold text-background-50 font-heading">Persianas</span>
                <span className="text-xs font-semibold text-accent-400 ml-2">Málaga</span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed mb-5 max-w-sm">
                Servicio técnico local en Málaga capital. Más de 10 años reparando persianas, mosquiteras y motorización. Tu tranquilidad empieza con una persiana que funciona.
              </p>
              <div className="flex flex-col gap-3">
                <a href="tel:+34951120770" className="inline-flex items-center gap-2.5 text-background-50 hover:text-accent-400 transition-colors text-sm whitespace-nowrap cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/15 group-hover:bg-primary-500/25 transition-colors">
                    <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-accent-400 text-sm"></i></span>
                  </div>
                  951 12 07 70
                </a>
                <a href="mailto:info@persianas-malaga.es" className="inline-flex items-center gap-2.5 text-background-50 hover:text-accent-400 transition-colors text-sm whitespace-nowrap cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/15 group-hover:bg-primary-500/25 transition-colors">
                    <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-fill text-accent-400 text-sm"></i></span>
                  </div>
                  info@persianas-malaga.es
                </a>
                <a href="https://wa.me/34627213347" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 text-background-50 hover:text-[#25D366] transition-colors text-sm whitespace-nowrap cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/15 group-hover:bg-[#25D366]/20 transition-colors">
                    <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill text-accent-400 text-sm"></i></span>
                  </div>
                  WhatsApp
                </a>
              </div>
            </div>

            {/* Services */}
            <div className="lg:col-span-2">
              <h4 className="text-xs font-semibold text-accent-400 uppercase tracking-wider mb-5">Servicios</h4>
              <div className="flex flex-col gap-3">
                {footerServices.map((s) => (
                  <Link key={s.path} to={s.path} className="inline-flex items-center gap-2.5 text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer group">
                    <span className="w-5 h-5 flex items-center justify-center"><i className={`${s.icon} text-primary-500 text-sm group-hover:text-accent-400 transition-colors`}></i></span>
                    {s.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Barrios */}
            <div className="lg:col-span-5">
              <h4 className="text-xs font-semibold text-accent-400 uppercase tracking-wider mb-5">Barrios de Málaga</h4>
              <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">
                {footerBarrios.map((b) => (
                  <Link key={b.path} to={b.path} className="inline-flex items-center gap-1.5 text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-fill text-primary-500 text-[10px]"></i></span>
                    {b.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact / Legal */}
            <div className="lg:col-span-2">
              <h4 className="text-xs font-semibold text-accent-400 uppercase tracking-wider mb-5">Legal</h4>
              <div className="flex flex-col gap-3 mb-6">
                {footerLegal.map((l) => (
                  <Link key={l.path} to={l.path} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    {l.label}
                  </Link>
                ))}
              </div>
              <div className="bg-secondary-800/50 rounded-xl p-4 border border-secondary-700/40">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-time-line text-accent-400 text-sm"></i></span>
                  <span className="text-xs font-semibold text-background-50">Horario</span>
                </div>
                <div className="space-y-1">
                  <div className="flex justify-between text-xs">
                    <span className="text-secondary-300">Lun–Vie</span>
                    <span className="text-background-50 font-medium">8:00 – 19:00</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span className="text-secondary-300">Sáb</span>
                    <span className="text-background-50 font-medium">9:00 – 14:00</span>
                  </div>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-secondary-700/40">
                <a
                  href="https://toldos-malaga.es"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center justify-center gap-2 w-full text-xs text-background-50/70 hover:text-accent-400 transition-colors py-2 rounded-lg bg-background-50/5 border border-secondary-700/40 cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-sun-line"></i></span>
                  ¿Buscas toldos? Próximamente en toldos-malaga.es
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-external-link-line"></i></span>
                </a>
              </div>
              <div className="mt-4 pt-4 border-t border-secondary-700/40">
                <a
                  href="https://www.google.com/maps/place/M%C3%A1laga,+Spain/@36.7212737,-4.4213988,14z"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center justify-center gap-2 w-full text-xs text-accent-400 hover:text-accent-300 transition-colors py-2 rounded-lg bg-accent-500/10 border border-accent-500/20 cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill"></i></span>
                  Déjanos tu reseña en Google
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-external-link-line"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-secondary-700/40">
          <div className="px-4 md:px-6 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">© 2026 Persianas Málaga. Todos los derechos reservados.</p>
            <div className="flex items-center gap-1.5 text-xs text-secondary-400">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-2-line text-accent-500"></i></span>
              Málaga capital y sus 16 barrios
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}